// OWNER: platform module. Header bell with unread count (FR-11.1). Mounted by app/layout/AppShell.tsx.
// The count is shown as a number (not colour alone) and announced in the link's accessible name.
import { Link as RouterLink } from 'react-router';
import { Bell } from 'lucide-react';
import { useUnreadCount } from './api';

export const bellLabel = (n: number) => (n > 0 ? `Notifications, ${n} new` : 'Notifications, none new');

export function NotificationBell({ wsId }: { wsId: string }) {
  const { data } = useUnreadCount(wsId);
  const unread = data?.count ?? 0;
  return (
    <RouterLink
      to={`/w/${wsId}/more/notifications`}
      className="relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-text hover:bg-surface-muted"
      aria-label={bellLabel(unread)}
    >
      <Bell aria-hidden="true" className="h-6 w-6" />
      {unread > 0 && (
        <span
          aria-hidden="true"
          data-testid="notification-badge"
          className="absolute -top-0.5 -right-0.5 inline-flex min-w-6 items-center justify-center rounded-full border-2 border-surface bg-danger px-1 text-sm leading-5 font-bold text-on-danger"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </RouterLink>
  );
}
